export const prepareBollingerBandsData = (data, bands) => {
    return {
        upper_band: data.map((d, i) => ({
            x: new Date(d.start_date),
            y: bands.upper_band[i] !== undefined ? bands.upper_band[i] : null,
        })),
        middle_band: data.map((d, i) => ({
            x: new Date(d.start_date),
            y: bands.middle_band[i] !== undefined ? bands.middle_band[i] : null,
        })),
        lower_band: data.map((d, i) => ({
            x: new Date(d.start_date),
            y: bands.lower_band[i] !== undefined ? bands.lower_band[i] : null,
        })),
    };
};
